// import React from 'react';
// import { ChevronLeft, Home, Zap, ShoppingCart, User, Search } from 'lucide-react';

// // Mock data for the electricity billers
// const billers = [
//     { name: 'DESCO Postpaid', code: '1071', logoText: 'DESCO', logoColor: 'text-blue-600', logoBg: 'bg-blue-50' },
//     { name: 'NESCO Postpaid', code: '1041', logoText: 'NESCO', logoColor: 'text-red-600', logoBg: 'bg-red-50' },
//     { name: 'NESCO Prepaid', code: '1076', logoText: 'NESCO', logoColor: 'text-red-600', logoBg: 'bg-red-50' },
//     { name: 'DPDC', code: '1014', logoText: 'DPDC', logoColor: 'text-gray-700', logoBg: 'bg-gray-200' },
//     { name: 'West Zone Power Distributor Company', code: '1092', logoText: 'WzPDC', logoColor: 'text-blue-800', logoBg: 'bg-blue-100' },
// ];

// // Reusable Biller Item component
// const BillerItem = ({ name, code, logoText, logoColor, logoBg,setActiveScreen}) => (
//     <div className="flex items-center py-4 px-1 border-b border-gray-100 last:border-b-0 cursor-pointer hover:bg-gray-50 transition duration-150 rounded-lg" onClick={()=>{
//         setActiveScreen('paymentEBillProviderDetails')
//     }}>
//         {/* Mock Logo/Icon Area */}
//         <div className={`w-10 h-10 rounded-full flex items-center justify-center mr-4 font-bold text-xs ${logoBg} ${logoColor} ring-1 ring-inset ring-gray-200`}>
//             {logoText.substring(0, 4)}
//         </div>
        
//         {/* Biller Info */}
//         <div className="flex-grow">
//             <p className="text-gray-800 font-medium">{name}</p>
//             <p className="text-sm text-gray-500">{code}</p>
//         </div>
//     </div>
// );

// // Main Application Component
// const PayEBill = ({onBack,setActiveScreen}) => {
//     const [searchTerm, setSearchTerm] = React.useState('');

//     // Filter billers based on search term (simulating real-time search)
//     const filteredBillers = billers.filter(biller =>
//         biller.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         biller.code.includes(searchTerm)
//     );

//     return (
//         // <div className="min-h-screen bg-gray-100 p-4 sm:p-0">
//             <div className="max-w-md mx-auto min-h-screen bg-white shadow-xl flex flex-col rounded-xl sm:rounded-none">

//                 {/* Header */}
//                 <header className="flex items-center p-4 border-b border-gray-200 sticky top-0 bg-white z-10">
//                     <button className="text-gray-600 hover:text-blue-500 transition" onClick={onBack}>
//                         <ChevronLeft className="w-6 h-6" />
//                     </button>
//                     <h1 className="flex-grow text-center text-lg font-semibold text-gray-800">Pay electricity</h1>
//                     {/* Placeholder to balance the back button */}
//                     <div className="w-6 h-6"></div> 
//                 </header>

//                 {/* Content Area */}
//                 <main className="flex-grow p-4 overflow-y-auto">
                    
//                     {/* Biller Search/Input Card */}
//                     <div className="bg-white p-5 rounded-2xl shadow-md mb-6">
//                         <label htmlFor="biller-search" className="block text-sm font-medium text-gray-700 mb-2">
//                             Enter Biller Name or Biller Number
//                         </label>
//                         <div className="relative">
//                             <input
//                                 id="biller-search"
//                                 type="text"
//                                 placeholder="Eg. KA00XX00000"
//                                 value={searchTerm}
//                                 onChange={(e) => setSearchTerm(e.target.value)}
//                                 className="w-full pl-4 pr-12 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition duration-150 text-gray-800 placeholder-gray-400"
//                             />
//                             <Search className="absolute right-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
//                         </div>
//                     </div>

//                     {/* All Billers List Card */}
//                     <div className="bg-white p-5 rounded-2xl shadow-md">
//                         <h2 className="text-lg font-bold text-gray-800 mb-4">All Billers</h2>
//                         <div className="divide-y divide-gray-100">
//                             {filteredBillers.length > 0 ? (
//                                 filteredBillers.map((biller, index) => (
//                                     <BillerItem 
//                                         key={index}
//                                         name={biller.name}
//                                         code={biller.code}
//                                         logoText={biller.logoText}
//                                         logoColor={biller.logoColor}
//                                         logoBg={biller.logoBg}

//                                         setActiveScreen={setActiveScreen}
//                                     />
//                                 ))
//                             ) : (
//                                 <p className="text-gray-500 py-4 text-center">No billers found matching your search.</p>
//                             )}
//                         </div>
//                     </div>

//                 </main>

//                 {/* Fixed Footer Navigation */}
//                 {/* <nav className="sticky bottom-0 bg-white border-t border-gray-200 py-2.5 shadow-md">
//                     <div className="flex justify-around items-center h-16">
//                         <a href="#" className="flex flex-col items-center text-gray-400 hover:text-blue-500 transition duration-150">
//                             <Home className="w-6 h-6" />
//                             <span className="text-xs mt-0.5">Home</span>
//                         </a>
//                         <a href="#" className="flex flex-col items-center text-blue-500 transition duration-150">
//                             <Zap className="w-6 h-6" />
//                             <span className="text-xs mt-0.5">Energy</span>
//                         </a>
//                         <a href="#" className="flex flex-col items-center text-gray-400 hover:text-blue-500 transition duration-150">
//                             <ShoppingCart className="w-6 h-6" />
//                             <span className="text-xs mt-0.5">Cart</span>
//                         </a>
//                         <a href="#" className="flex flex-col items-center text-gray-400 hover:text-blue-500 transition duration-150">
//                             <User className="w-6 h-6" />
//                             <span className="text-xs mt-0.5">Profile</span>
//                         </a>
//                     </div>
//                     <div className="h-1 w-24 mx-auto bg-gray-300 rounded-full mt-1"></div>
//                 </nav> */}
//             </div>
//         // </div>
//     );
// };

// export default PayEBill;



import React, { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, Search, Loader2, Zap } from 'lucide-react';
import { useBackHandler } from '../../hooks/androidbackHandler';
import { useCapacitorBackHandler } from '../../hooks/billbackHandler';
import { API_BASE_URL } from '../../config/api';
// import { useAndroidBackHandler } from '../../hooks/androidbackHandler';

// API Endpoint for billers. categoryId will be interpolated.
const BILLERS_API_BASE_URL = `${API_BASE_URL}/utility-transactions/billers`;

// Reusable Biller Item component
const BillerItem = ({ name, id, logoUrl, onSelect }) => (
    // Note: 'code' prop is replaced with 'id' since API provides 'Id'
    <div 
        className="flex items-center py-4 px-1 border-b border-gray-100 last:border-b-0 cursor-pointer hover:bg-gray-50 transition duration-150 rounded-lg" 
        onClick={() => onSelect({ name, id })} // Pass id (as biller code/ID) and name
    >
        {/* Biller Logo/Icon Area */}
        <div className={`w-10 h-10 rounded-full flex items-center justify-center mr-4 font-bold text-xs bg-gray-200 text-gray-700 ring-1 ring-inset ring-gray-200`}>
             {logoUrl ? (
                 // Assuming logoUrl is a full URL. If it's just a file name (like 'q.gif'), 
                 // you'll need a base URL prepend here. For now, we assume it's usable.
                 <img src={logoUrl} alt={name} className="w-8 h-8 object-contain rounded-full" />
             ) : (
                 <span>{name.substring(0, 4)}</span>
             )}
        </div>
        
        {/* Biller Info */}
        <div className="flex-grow">
            <p className="text-gray-800 font-medium">{name}</p>
            {/* Displaying ID/Code using the API's Id field */}
            <p className="text-sm text-gray-500">Provider ID: {id}</p>
        </div>
    </div>
);

// Main Component: SelectBillerScreen
const SelectBillerScreen = ({ onBack, setActiveScreen, categoryId, categoryName, authToken }) => {

    //    const handleNativeBack = () => {
    //         // This is the same function passed as 'onBack' prop
    //         onBack(); 
    //     };
        
    //     // Apply the hook with the custom action
    //     useAndroidBackHandler(handleNativeBack);

    const [searchTerm, setSearchTerm] = useState('');
    const [billers, setBillers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // --- Data Fetching Logic (Updated) ---
    const fetchBillers = useCallback(async () => {
        if (!authToken || !categoryId) {
            setError('Missing authentication or category details.');
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        setError(null);
        
        try {
            const URL = `${BILLERS_API_BASE_URL}/${categoryId}`;
            
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}` 
                },
            });

            if (!response.ok) {
                const errorDetail = await response.json();
                throw new Error(`Failed to fetch billers. Status: ${response.status}. Detail: ${errorDetail.message || response.statusText}`);
            }

            const result = await response.json();
            
            // Check for SUCCESS status based on API response structure
            if (result.status !== "SUCCESS") {
                 throw new Error(result.message || 'Failed to fetch billers from API.');
            }

            const fetchedBillers = result?.data?.billers || []; 
            
            // 💡 FIX: Map API response keys to component-friendly keys
            const mappedBillers = fetchedBillers.map(b => ({
                id: b.Id ?? 0,             // Use API's Id as the unique ID/code
                name: b.Name ?? '',         // Use API's Name
                logoUrl: b.LogoUrl ?? null,   // Use API's LogoUrl
            }));

            setBillers(mappedBillers);

        } catch (err) {
            console.error(`Failed to fetch billers for category ${categoryId}:`, err);
            setError(err.message || 'Network error while fetching providers.');
            setBillers([]); // Clear billers on error
        } finally {
            setIsLoading(false); 
        }
    }, [authToken, categoryId]);

    // Effect to trigger initial fetch on mount
    useEffect(() => {
        fetchBillers();
    }, [fetchBillers]);


    // 💡 FIX: Filter billers based on search term using the mapped keys
    const filteredBillers = billers.filter(biller =>
        biller.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        String(biller.id).includes(searchTerm) 
    );
    
    // Handle Biller Selection (simulates navigating to the next screen)
    const handleBillerSelect = (biller) => {
        console.log("Selected Biller:", biller);
        // 💡 FIX: Pass the biller.id (which holds the API's 'Id') to the next screen
        setActiveScreen('paymentEBillProviderDetails', { 
            billerId: biller.id, 
            billerName: biller.name,
            categoryId: categoryId, // Pass Category ID for context in the next screen
            categoryName: categoryName // Pass Category Name for context in the next screen
        });
    };

    // useBackHandler(onBack);
    const handleNativeBack = useCallback(() => {
         onBack();
    }, [onBack]);

 
    useCapacitorBackHandler(handleNativeBack);

    return (
        <div className="">

            {/* Header */}
            <header className="flex items-center p-4 border-b border-gray-200 sticky top-0 bg-white z-10">
                <button className="text-gray-600 hover:text-blue-500 transition" onClick={onBack}>
                    <ChevronLeft className="w-6 h-6" />
                </button>
                <h1 className="flex-grow text-center text-lg font-semibold text-gray-800">
                    Pay {categoryName || 'Bill'}
                </h1>
                <div className="w-6 h-6"></div> 
            </header>

            {/* Content Area */}
            <main className="flex-grow p-4 overflow-y-auto">
                
                {/* Biller Search/Input Card */}
                <div className="bg-white p-5 rounded-2xl shadow-md mb-6">
                    <label htmlFor="biller-search" className="block text-sm font-medium text-gray-700 mb-2">
                        Enter Provider Name or ID
                    </label>
                    <div className="relative">
                        <input
                            id="biller-search"
                            type="text"
                            placeholder="Search providers..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full pl-4 pr-12 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition duration-150 text-gray-800 placeholder-gray-400"
                        />
                        <Search className="absolute right-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                    </div>
                </div>

                {/* All Billers List Card */}
                <div className="bg-white p-5 rounded-2xl shadow-md">
                    <h2 className="text-lg font-bold text-gray-800 mb-4">All Providers for {categoryName}</h2>
                    
                    {isLoading && (
                        <div className="flex justify-center items-center py-10">
                            <Loader2 className="w-8 h-8 text-blue-600 animate-spin mr-2" />
                            <span className="text-gray-600">Loading providers...</span>
                        </div>
                    )}
                    
                    {error && !isLoading && (
                        <div className="text-center py-10 text-red-600 font-medium p-4 bg-red-50 rounded-lg">
                            <Zap className="w-6 h-6 mx-auto mb-2" />
                            {error}
                            <button onClick={fetchBillers} className="mt-2 text-blue-600 underline text-sm">Retry Load</button>
                        </div>
                    )}

                    {!isLoading && !error && (
                        <div className="divide-y divide-gray-100">
                            {filteredBillers.length > 0 ? (
                                filteredBillers.map((biller, index) => (
                                    <BillerItem 
                                        key={biller.id}
                                        id={biller.id}        // Pass ID
                                        name={biller.name}    // Pass Name
                                        logoUrl={biller.logoUrl} // Pass Logo URL
                                        onSelect={handleBillerSelect}
                                    />
                                ))
                            ) : (
                                <p className="text-gray-500 py-4 text-center">No providers found matching your search.</p>
                            )}
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
};

export default SelectBillerScreen;
